/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:09
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-10-24 14:56:24
 * @FilePath: \ioc_base\src\modules\peopleInfo\options\visitorType.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const visitorTypeOption = function () {
  return {
    labelWidth: 100,
    emptyBtn: false,
    submitBtn: false,
    column: [{
      label: '类型名称',
      span: 24,
      prop: 'name',
      type:"input",
      maxlength:32,
      // disabled: true,
      rules: [{
        required: true,
        message: '请输入类型名称',
        trigger: 'change',
      }]
    }]
  }
}

export default visitorTypeOption